// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"420":"Lazy-KayentaGraphs","500":"Lazy-Kayenta-Tabs"}[chunkId] || chunkId) + ".js";
};